/* eslint-disable */

import {
  Grid,
  Paper,
  TextField,
  Typography,
  Box,
  Autocomplete,
  FormLabel,
  FormControl,
  Button,
  MenuItem,
  Menu,
  Fade,
  CircularProgress,
  InputAdornment,
  Checkbox,
  Toolbar,
  Divider,
  IconButton,
  Tooltip,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import axios from 'axios';
import { toast } from 'react-toastify';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';

import { useResponsiveStyles } from '../../../utils/responsiveStyles';
import Key from '../../../clientVariables.json';
import HoldReason from './HoldReason';
import InvoiceForm from './InoviceForm';
import CustomerConfirmationDialog from './CustomerConfirmationDialog';
import SessionAlert from '../../../SessionAlert';
import { ArrowBackIosRounded, DescriptionRounded, FileDownloadRounded, UploadFileRounded } from '@mui/icons-material';
import ContractActions from './ContractActions';
import ViewContract from './ViewContract';
import CreateAgreementButton from './CreateAgreementButton';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const initialRows = [];

// const statusData = ["Entered", "Hold (unable to renew)", "Emailed", "Signed/Approved", "Active", "Expired", "Terminate", "Canceled (if not signed)"];
const initialState = {
  id: '', // Summary Number
  customerEmail: null,
  description: '',
  startDate: moment(),
  endDate: null,
  duration: '',
  period: '',
  subTotal: 0,
  tax: 0,
  grandTotal: 0,
  status: {
    status_id: 1,
    status_name: 'Entered',
  },
  priceList: { name: 'Monthly', id: 1 },
  totalDiscount: 0,
  days: 1,
  package: 'Standard',
  isTrail: true,
  trailDays: 3,
};

const packages = ['Standard', 'Custom'];
const plans = [
  { name: 'Monthly', id: 1 },
  // {name:"Yearly"}
];

const Summary = () => {
  const styles = useResponsiveStyles();
  const [tabValue, setTabValue] = useState(0);
  const currentUser = useSelector((state) => state.UserReducer.user);
  const selectedContract = useSelector((state) => state.contractsManagement.selectedContract);
  const [statusData, setStatusData] = useState([]);
  const [formData, setFormData] = useState(initialState);
  const [rows, setRows] = useState(initialRows);
  const [rowModesModel, setRowModesModel] = useState({});
  const [priceListData, setPriceListData] = useState([]);
  const [priceListDataByID, setPriceListDataByID] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [selectedCustomerDetails, setSelectedCustomerDetails] = useState(null);
  const [isHoldReasonOpen, setIsHoldReasonOpen] = useState(false);
  const [action, setAction] = useState(null);
  const [selectedPriceListItems, setSelectedPriceListItems] = useState([]);
  const [isOpenInvoiceForm, setisOpenInvoiceForm] = useState({
    isOpen: false,
    rowData: [],
    summaryData: {},
  });
  const [customerConfirmationDilogOpen, setCustomerConfirmationDilogOpen] = useState(false);
  const [changeContract, setChangeContract] = useState(null);
  const [addOnRows, setAddOnRows] = useState(1);
  const [sessionAlert, setSessionAlert] = useState(false);
  const [stateList, setStateList] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    getPriceList();
    getCustomers();
    getStatusList();
    getStates();
    setFormData((prev) => ({
      ...prev,
      package: 'Standard',
      // priceList:
      // { id: 1, name: 'Basic Price List' },
      // {
      //   id: 1,
      //   admin_id: 31,
      //   name: "Basic Price List",
      //   status: 1,
      //   created: "2024-07-12T16:12:32.000Z",
      //   created_by: 31,
      //   approved_by: 29,
      //   items: "{\"item_id\": \"QKEAP6\", \"name\": \"Profile\", \"price\": \"0.14\", \"description\": \"Resume Views\", \"type\": \"Intangable\", \"uom\": \"Each Profile\"},{\"item_id\": \"KYFUKN\", \"name\": \"User\", \"price\": \"3.33\", \"description\": \"Recruiters\", \"type\": \"Intangable\", \"uom\": \"Each User\"},{\"item_id\": \"T4M080\", \"name\": \"Job\", \"price\": \"0\", \"description\": \"Job Postings\", \"type\": \"Intangable\", \"uom\": \"Each Job\"}"
      // },
    }));
  }, []);

  useEffect(() => {
    const fetch = async () => {
      if (selectedContract && selectedContract === 'No Contract found') {
        setCustomerConfirmationDilogOpen(false);
        setFormData((prev) => ({
          ...prev,
          id: generateContractId(),
        }));
      } else {
        if (selectedContract?.file_name || selectedContract?.contract_filename) {
          setChangeContract('change-agreement');
        } else {
          setChangeContract('saved-contract');
        }
        if (selectedContract && Object(selectedContract).length !== 0 && selectedContract?.number) {
          const customerSavedData = selectedContract;
          const priceListPrev = priceListData.filter((item) => item.id === customerSavedData?.price_list_id);
          const statusPrev = statusData.filter((item) => item.status_id === customerSavedData?.contract_status);
          const daysCal = calculateDaysDifference(customerSavedData?.start_date, customerSavedData?.end_date);

          setFormData((prev) => ({
            ...prev,
            id: generateContractId(),
            customerEmail: customerSavedData?.email,
            description: customerSavedData?.description,
            duration: customerSavedData?.duration,
            grandTotal: customerSavedData?.total,
            subTotal: customerSavedData?.sub_total,
            period: customerSavedData?.period,
            priceList: priceListPrev[0],
            //   contract_status: statusPrev[0],
            tax: 0,
            totalDiscount: customerSavedData?.discount,
            startDate: moment(customerSavedData?.start_date),
            endDate: moment(customerSavedData?.end_date),
            days: daysCal,
            status: statusPrev[0],
            isTrail: customerSavedData?.trail_days == 0 ? false : true,
            trailDays: customerSavedData?.trail_days == 0 ? 0 : 3,
          }));

          const newRows =
            (await customerSavedData?.items.length) > 0
              ? customerSavedData?.items.map((item, index) => ({
                  id: item.id,
                  itemID: item.item_id,
                  name: item.name,
                  description: item.description,
                  uom: item.uom,
                  quantity: item.quantity,
                  price: item.price,
                  discount: item.discount,
                  lineTotal: calculateLineTotal(
                    item.quantity,
                    item.price,
                    item.discount,
                    item.item_id,
                    daysCal,
                    item.name
                  ),
                  status: '',
                  serialNumber: index + 1,
                  isNew: false,
                }))
              : [];

          setRows(newRows);
        } else {
          setFormData((prev) => ({
            ...prev,
            id: generateContractId(),
          }));
          setChangeContract(null);
        }
      }

      setAction(null);
    };
    fetch();
  }, [dispatch, selectedContract]);

  useEffect(() => {
    if (formData.package === 'Standard') {
      handleChange('priceList', { id: 1, name: 'Monthly' });
    } else {
      handleChange('priceList', priceListData[0]);
    }
    // console.log('Trail: ', formData.isTrail, formData.trailDays);
    if (!formData.isTrail) {
      handleChange('trailDays', 0);
    } else {
      handleChange('trailDays', 3);
    }
    if (formData.isTrail) {
      let datesWithTrial = calculateDates(formData.trailDays, 30);
      // console.log('With 3 days Trial:', datesWithTrial);
      setFormData((prev) => ({
        ...prev,
        startDate: moment(datesWithTrial.trialEndDate),
        endDate: moment(datesWithTrial.endDate),
        // priceList: priceListData[0],
      }));
    } else {
      let datesWithoutTrial = calculateDates(formData.trailDays, 30);
      // console.log('Without Trial:', datesWithoutTrial);
      setFormData((prev) => ({
        ...prev,
        startDate: moment(datesWithoutTrial.trialEndDate),
        endDate: moment(datesWithoutTrial.endDate),
        // priceList: priceListData[0],
      }));
    }
  }, [formData.package, formData.isTrail, formData.trailDays]);
  // useEffect(() => {
  //   handleChange("trialDays", formData.isTrail ? 3 : 0);

  //   const dates = calculateDates(formData.trailDays, 30);
  //   console.log(formData.isTrail ? 'With 3 days Trial:' : 'Without Trial:', dates, formData.trailDays, formData.isTrail);

  //   setFormData((prev) => ({
  //     ...prev,
  //     startDate: moment(dates.trialEndDate),
  //     endDate: moment(dates.endDate),
  //     priceList: priceListData[0],
  //   }));
  // }, [formData.package, formData.isTrail, formData.trailDays]);

  useEffect(() => {
    calculateDurationAndPeriod();

    if (formData.startDate && formData.endDate) {
      const daysCaluculate = calculateDaysDifference(formData.startDate, formData.endDate);
      setFormData((prev) => ({
        ...prev,
        days: daysCaluculate,
      }));
    }
  }, [formData.startDate, formData.endDate]);

  useEffect(() => {
    if (formData.priceList && formData.priceList.id) {
      // console.log('pricelist ', formData.priceList.id);
      getItemById(formData.priceList.id);
    }
    // else if(formData.priceList.name === "Monthly"){
    //   getItemById(1);
    // }
    else {
      setRows([]);
    }
  }, [formData.priceList]);

  useEffect(() => {
    if (rows.length === 0) return;

    const updatedRows = rows.map((row) => {
      if (row.name === 'Profile') {
        let newQuantity = 0;

        if (formData.days < 32) {
          newQuantity = formData.days * 40;
        } else if (formData.days >= 32 && formData.days < 92) {
          newQuantity = formData.days * 45;
        } else if (formData.days >= 92 && formData.days < 182) {
          newQuantity = formData.days * 55;
        } else if (formData.days >= 182) {
          newQuantity = formData.days * 65;
        }

        return {
          ...row,
          quantity: newQuantity,
          lineTotal: calculateLineTotal(newQuantity, row.price, 0, row.itemID, formData.days, row.name),
        };
      } else {
        return {
          ...row,
          lineTotal: calculateLineTotal(row.quantity, row.price, 0, row.itemID, formData.days, row.name),
        };
      }
    });

    setRows(updatedRows);

    const subTotal = Math.round(updatedRows.reduce((total, row) => total + Number(row.lineTotal), 0).toFixed(2));
    const totalDiscount = Math.round(
      updatedRows.reduce((total, row) => total + row.price * row.quantity * (row.discount / 100), 0).toFixed(2)
    );
    const grandTotal = Math.round((subTotal - totalDiscount).toFixed(2));

    handleChange('subTotal', subTotal);
    handleChange('totalDiscount', totalDiscount);
    handleChange('grandTotal', grandTotal);
  }, [formData.days]);

  function calculateDates(trialPeriodDays, durationDays) {
    // Get the current date
    let startDate = new Date();

    // Calculate the trial end date
    let trialEndDate = new Date();
    trialEndDate.setDate(startDate.getDate() + trialPeriodDays);

    // Calculate the actual end date based on the trial period and total duration
    let endDate = new Date(trialEndDate);
    endDate.setDate(trialEndDate.getDate() + durationDays);

    // Format the dates as needed (e.g., YYYY-MM-DD)
    let formattedStartDate = startDate.toISOString().split('T')[0];
    let formattedTrialEndDate = trialEndDate.toISOString().split('T')[0];
    let formattedEndDate = endDate.toISOString().split('T')[0];

    return {
      startDate: formattedStartDate,
      trialEndDate: formattedTrialEndDate,
      endDate: formattedEndDate,
    };
  }

  const calculateDurationAndPeriod = () => {
    if (formData.startDate && formData.endDate) {
      const start = new Date(formData.startDate);
      const end = new Date(formData.endDate);

      // Calculate duration in days
      const diffInMilliseconds = Math.abs(end - start);
      const days = Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24));
      // setDurationInDays(days);

      // Calculate period in years, months, days
      let years = end.getFullYear() - start.getFullYear();
      let months = end.getMonth() - start.getMonth();
      let diffDays = end.getDate() - start.getDate();

      // Adjust for negative months or days
      if (months < 0 || (months === 0 && end.getDate() < start.getDate())) {
        years--;
        months += 12;
      }
      if (diffDays < 0) {
        const tempDate = new Date(end.getFullYear(), end.getMonth(), 0);
        diffDays = tempDate.getDate() - start.getDate() + end.getDate();
        months--;
      }
      // console.log('period', years, months, diffDays);
      if (diffDays > 0) {
        handleChange('duration', days);
        if (days === 1) {
          handleChange('period', 'day');
        } else {
          handleChange('period', 'days');
        }
      } else if (years > 0 && months > 0) {
        // setDurationInDays(days);
        // if(days === 1){
        //   setDurationPeriod('day');
        // }else{
        //   setDurationPeriod('days');
        // }
        const monthsCaluculations = years * 12 + months;
        handleChange('duration', monthsCaluculations);
        handleChange('period', 'months');
      } else {
        if (years > 0) {
          if (years === 1) {
            handleChange('duration', years);
            handleChange('period', 'year');
          } else {
            handleChange('duration', years);
            handleChange('period', 'years');
          }
        } else if (months > 0) {
          if (months === 1) {
            handleChange('duration', months);
            handleChange('period', 'month');
          } else {
            handleChange('duration', months);
            handleChange('period', 'months');
          }
        } else {
          // if(days === 1){
          //   setDurationPeriod('day');
          // }else{
          //   setDurationPeriod('days');
          // }
        }
      }
      // setDurationInDays(days);
      // Construct period string
      // const period = [];
      // if (years > 0) {
      //   period.push(`${years} ${years === 1 ? 'year' : 'years'}`);
      // }
      // if (months > 0) {
      //   period.push(`${months} ${months === 1 ? 'month' : 'months'}`);
      // }
      // if (diffDays > 0) {
      //   period.push(`${diffDays} ${diffDays === 1 ? 'day' : 'days'}`);
      // }
      // setDurationPeriod(period.join(' '));
    }
  };

  // useEffect(() => {
  //   if (rows.length === 0) return;

  //   setRows((prevRows) => {
  //     const updatedRows = prevRows.map((row) => {
  //       if (row.id === 'QKEAP6') {
  //         let newQuantity = 0;

  //         if (formData.days < 32) {
  //           newQuantity = formData.days * 40;
  //         } else if (formData.days >= 32 && formData.days < 92) {
  //           newQuantity = formData.days * 45;
  //         } else if (formData.days >= 92 && formData.days < 182) {
  //           newQuantity = formData.days * 55;
  //         } else if (formData.days >= 182) {
  //           newQuantity = formData.days * 65;
  //         }

  //         return {
  //           ...row,
  //           quantity: newQuantity,
  //           lineTotal: calculateLineTotal(newQuantity, row.price, 0, row.id),
  //         };
  //       } else {
  //         return {
  //           ...row,
  //           lineTotal: calculateLineTotal(row.quantity, row.price, 0, row.id),
  //         };
  //       }
  //     });

  //     const subTotal = parseFloat(updatedRows.reduce((total, row) => total + Number(row.lineTotal), 0).toFixed(2));
  //     const totalDiscount = parseFloat(
  //       updatedRows.reduce((total, row) => total + row.price * row.quantity * (row.discount / 100), 0).toFixed(2)
  //     );
  //     const grandTotal = parseFloat((subTotal - totalDiscount).toFixed(2));

  //     handleChange('subTotal', subTotal);
  //     handleChange('totalDiscount', totalDiscount);
  //     handleChange('grandTotal', grandTotal);

  //     return updatedRows;
  //   });
  // }, [formData.days]);

  // useEffect(() => {
  //   if (rows.length === 0) return;

  //   setRows((prevRows) => {
  //     return prevRows.map((row) => {
  //       if (row.id === 'QKEAP6') {
  //         let newQuantity = 0;
  //         let newLineTotal = 0;

  //         if (formData.days < 32) {
  //           newQuantity = formData.days * 40;
  //         } else if (formData.days >= 32 && formData.days < 92) {
  //           newQuantity = formData.days * 45;
  //         } else if (formData.days >= 92 && formData.days < 182) {
  //           newQuantity = formData.days * 55;
  //         } else if (formData.days >= 182) {
  //           newQuantity = formData.days * 65;
  //         }

  //         return {
  //           ...row,
  //           quantity: newQuantity,
  //           lineTotal: calculateLineTotal(newQuantity, row.price, 0, row.id),
  //         };
  //       }else{
  //         return {
  //           ...row,
  //           lineTotal: calculateLineTotal(row.quantity, row.price, 0, row.id),
  //         };
  //       }

  //       // return row;
  //     });
  //   });

  //   const subTotal = parseFloat(rows.reduce((total, row) => total + Number(row.lineTotal), 0).toFixed(2));
  //   const totalDiscount = parseFloat(
  //     rows.reduce((total, row) => total + row.price * row.quantity * (row.discount / 100), 0).toFixed(2)
  //   );
  //   const grandTotal = parseFloat((subTotal - totalDiscount).toFixed(2));

  //   handleChange('subTotal', subTotal);
  //   handleChange('totalDiscount', totalDiscount);
  //   handleChange('grandTotal', grandTotal);

  // }, [formData.days]);
  const handleChange = (field, value) => {
    const formattedValue =
      field === 'endDate' || field === 'startDate' ? moment(value).utc().format('YYYY-MM-DD HH:mm:ss') : value;

    setFormData((prev) => ({
      ...prev,
      [field]: formattedValue,
    }));
  };
  // const handleChange = (feild, value) => {
  //   // console.log(formData);
  //   setFormData((prev) => ({
  //     ...prev,
  //     [feild]: value,
  //   }));
  // };

  const calculateLineTotal = (quantity, price, discountPercentage, id, days, name) => {
    if (quantity === 0 || price === 0) return 0;
    // console.log('caluculateLineTotal', quantity, price, discountPercentage, id, days);
    const discountAmount = (discountPercentage / 100) * (quantity * price);
    if (name === 'User') {
      return Math.round((quantity * (price * days)).toFixed(2));
    } else if (name === 'Profile') {
      let fixedViews = 0;
      if (days < 32) {
        fixedViews = days * 40;
      } else if (days >= 32 && days < 92) {
        fixedViews = days * 45;
      } else if (days >= 92 && days < 182) {
        fixedViews = days * 55;
      } else if (days >= 182) {
        fixedViews = days * 65;
      }

      const excessViewsQuantity = Math.max(0, quantity - fixedViews);
      return Math.round((excessViewsQuantity * price).toFixed(2));
    } else {
      return Math.round((quantity * price - discountAmount).toFixed(2));
    }
  };

  // const calculateLineTotal = (quantity, price, discountPercentage, id) => {
  //   const discountAmount = (discountPercentage / 100) * (quantity * price);
  //   // handleChange('totalDiscount', parseFloat(discountAmount.toFixed(2)));
  //   // return parseFloat(((quantity * price) - discountAmount).toFixed(2));
  //   if(id === 'KYFUKN'){
  //     return parseFloat((quantity * (price * formData.days)).toFixed(2));
  //   }
  //   else if(id === 'QKEAP6'){
  //     let caluculateViewsQuantityByDays = 0;
  //     let caluculateRemoveQuantity = 1200;
  //     if(formData.days < 32){
  //       let fixedViews = formData.days * 40; // plan days * per day 40 views
  //       let ecsessViewsQuantity = 0;
  //       if(fixedViews < quantity){
  //         ecsessViewsQuantity = quantity - fixedViews;
  //       }
  //       return parseFloat((ecsessViewsQuantity * price).toFixed(2));
  //     }else if(32 <= formData.days < 92){
  //       let fixedViews = formData.days * 45; // plan days * per day 45 views
  //       let ecsessViewsQuantity = 0;
  //       if(fixedViews < quantity){
  //         ecsessViewsQuantity = quantity - fixedViews;
  //       }
  //       return parseFloat((ecsessViewsQuantity * price).toFixed(2));
  //     }else if(92 <= formData.days < 182){
  //       let fixedViews = formData.days * 55; // plan days * per day 55 views
  //       let ecsessViewsQuantity = 0;
  //       if(fixedViews < quantity){
  //         ecsessViewsQuantity = quantity - fixedViews;
  //       }
  //       return parseFloat((ecsessViewsQuantity * price).toFixed(2));
  //     }else if(182 <= formData.days){
  //       let fixedViews = formData.days * 65; // plan days * per day 65 views
  //       let ecsessViewsQuantity = 0;
  //       if(fixedViews < quantity){
  //         ecsessViewsQuantity = quantity - fixedViews;
  //       }
  //       return parseFloat((ecsessViewsQuantity * price).toFixed(2));
  //     }
  //   }
  //   else {
  //   return parseFloat((quantity * price).toFixed(2));
  //   }
  // };

  //   const calculateLineTotal = (quantity, price, discount) => {
  //     const priceValue = price || 0;
  //     const discountValue = discount || 0;
  //     const quantityValue = quantity || 0;
  //     const discountAmount = (priceValue * discountValue) / 100;
  //     handleChange('totalDiscount', discountAmount);
  //     return quantityValue * (priceValue - discountAmount);
  //   };

  const handleCustomerInputChange = (inputValue) => {
    getCustomersByValue(inputValue);
    // console.log('Input Value', inputValue);
  };

  //   const handleCustomerChange = (field, value) => {
  //     setFormData((prev) => ({
  //       ...prev,
  //       [field]: value,
  //     }));

  //     // if (value) {
  //     //   getCustomersByValue(value);
  //     // }
  //     console.log("Value 11", value);
  //   };

  // const getCustomersByValue = async (searchText) => {
  //   try {
  //     const response = await axios.get(`${Key.domain}/admin/get_employers/${searchText}`);
  //     console.log(response.data);
  //     if(response.status === 200){
  //       setCustomerData(response.data.data.users);
  //     if(response.data.data.users.length === 1){
  //       getCustomerDetails(response.data.data.users[0]);
  //     }
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // const getCustomerDetails = async() => {
  //   setCustomerConfirmationDilogOpen(false);
  //   try {
  //     const response = await axios.get(`${Key.domain}/payment/contract/${selectedContract?.customer_id}`);
  //     console.log(response.data);
  //     if(response.status === 200){
  //       console.log('select customer', response.data.data);
  //       if(response.data.data === "No Summary found"){
  //         setCustomerConfirmationDilogOpen(false);
  //         setFormData((prev) => ({
  //           ...prev,
  //           id: generateContractId(),
  //         }));

  //       }else{
  //         if(response.data.data?.file_name){
  //           setSelectedCustomerDetails(response.data.data);
  //         //   setCustomerConfirmationDilogOpen(true);
  //         setChangeContract('change-agreement');
  //         }else{
  //           setChangeContract("saved-contract");
  //           setSelectedCustomerDetails(response.data.data);
  //           const customerSavedData = response.data.data;
  //     const priceListPrev = priceListData.filter((item) => item.id === customerSavedData?.price_list_id);
  //     const statusPrev = statusData.filter((item) => item.status_id === customerSavedData?.contract_status);
  //           const daysCal = calculateDaysDifference(customerSavedData.start_date, customerSavedData.end_date);
  //     setFormData((prev) => ({
  //       ...prev,
  //       id: generateContractId(),
  //       customerEmail: customerSavedData?.email,
  //       description: customerSavedData?.description,
  //       duration: customerSavedData?.duration,
  //       grandTotal: customerSavedData?.total,
  //       subTotal: customerSavedData?.sub_total,
  //       period: customerSavedData?.period,
  //       priceList: priceListPrev[0],
  //       contract_status: statusPrev[0],
  //       tax: 0,
  //       totalDiscount: customerSavedData?.discount,
  //       startDate: moment(customerSavedData?.start_date),
  //       endDate: moment(customerSavedData?.end_date),
  //       days: daysCal,
  //     }));

  //     const newRows =await customerSavedData.items.map((item, index) => ({
  //       id: item.id,
  //       itemID: item.item_id,
  //       name: item.name,
  //       description: item.description,
  //       uom: item.uom,
  //       quantity: item.quantity,
  //       price: item.price,
  //       discount: item.discount,
  //       lineTotal: calculateLineTotal(item.quantity, item.price, item.discount, item.item_id, daysCal, item.name),
  //       status: "",
  //       serialNumber: index + 1,
  //       isNew: false,
  //     }));

  //     setRows(newRows);
  //         }
  //       }

  //     }
  //   } catch (error) {
  //     console.error(error);
  //     setCustomerConfirmationDilogOpen(false);
  //   }
  // };

  const getStates = () => {
    fetch(`${Key.domain}/common/get_states_by_countryid`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        country_id: 233,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        setStateList(data.data);
      })
      .catch((error) => {
        console.error('Error fetching states:', error);
      });
  };
  const generateContractId = () => {
    const region = stateList.filter((data) => data.id == selectedContract?.stateid)[0];
    const shortRegion = region && region !== undefined ? region?.shortRegion : 'US';
    // customerData[0].state;
    // console.log(region);
    // const paddedUserId = customerData ? customerData[0]?.id.toString().padStart(6, '0') : '0';
    const newContractId = `JNP${shortRegion}${currentUser?.id}${moment().format('YYYYMMDDHHmmss')}`;
    // console.log('moment().format("YYYYMMDDHHMM")', moment().format("YYYYMMDDhhmmss"));
    return newContractId;
  };

  const contractConfirmationHandler = (data) => {
    if (data === 'cancel') {
      setFormData(initialState);
      // setRows(initialRows);
      setChangeContract(null);
    } else if (data === 'add-ons' || data === 'change-agreement') {
      const priceListPrev = priceListData.filter((item) => item.id === selectedContract?.price_list_id);
      const statusPrev = statusData.filter((item) => item.status_id === selectedContract?.contract_status);
      const daysCal = calculateDaysDifference(selectedContract.start_date, selectedContract.end_date);

      setFormData((prev) => ({
        ...prev,
        id: generateContractId(),
        description: selectedContract?.description,
        duration: selectedContract?.duration,
        grandTotal: selectedContract?.total,
        subTotal: selectedContract?.sub_total,
        period: selectedContract?.period,
        priceList: priceListPrev[0],
        contract_status: statusPrev[0],
        tax: 0,
        totalDiscount: selectedContract?.discount,
        startDate: moment(selectedContract?.start_date),
        endDate: moment(selectedContract?.end_date),
        days: daysCal,
      }));

      const newRows = selectedContract.items.map((item, index) => ({
        id: item.id,
        itemID: item.item_id,
        name: item.name,
        description: item.description,
        uom: item.uom,
        quantity: item.quantity,
        price: item.price,
        discount: item.discount,
        lineTotal: calculateLineTotal(item.quantity, item.price, item.discount, item.item_id, daysCal, item.name),
        status: item.status,
        serialNumber: index + 1,
        isNew: false,
      }));

      setRows(newRows);
      setChangeContract(data);
    }
  };

  //   const contractConfirmationHandler = (data) => {
  //     if(data === 'cancel'){
  //       setFormData(initialState);
  //       setRows(initialRows);
  //       setChangeContract(null);
  //     }else if(data === 'add-ons' || data === 'change-agreement'){
  //       const priceListPrev = priceListData.filter((item) => item.id === selectedContract?.price_list_id);
  //       const statusPrev = statusData.filter((item) => item.status_id === selectedContract?.status);
  //       console.log('priceListPrev', priceListPrev);
  //       setFormData((prev) => ({
  //         ...prev,
  //         id: generateContractId(),
  //         description: selectedContract?.description,
  //         duration: selectedContract?.duration,
  //         endDate: moment(selectedContract?.endDate),
  //         startDate: moment(selectedContract?.start_date),
  //         grandTotal: selectedContract?.total,
  //         subTotal: selectedContract?.sub_total,
  //         period: selectedContract?.period,
  //         priceList: priceListPrev[0],
  //         status: statusPrev[0],
  //         tax: 0,
  //         totalDiscount: selectedContract?.discount,
  //       }));

  //       // const parsedItems = JSON.parse(`[${selectedContract.items}]`);
  //       console.log('selectedContract', selectedContract);
  //       const newRowsChanged = selectedContract.items.map((item, index) => ({
  //         id: item.item_id,
  //         name: item.name,
  //         description: item.description,
  //         uom: item.uom,
  //         quantity: item.quantity,
  //         price: item.price,
  //         discount: item.discount,
  //         lineTotal: item.line_total,
  //         status: item.status,
  //         serialNumber: index + 1,
  //         // action: '',
  //         isNew: false,
  //       }));
  //       const newRowsAddOns = selectedContract.items.map((item, index) => ({
  //         id: item.item_id,
  //         name: item.name,
  //         description: item.description,
  //         uom: item.uom,
  //         quantity: item.quantity,
  //         price: item.price,
  //         discount: item.discount,
  //         lineTotal: item.line_total,
  //         status: item.status,
  //         // serialNumber: 'prev' + (index + 1),
  //         // action: '',
  //         isNew: false,
  //       }));
  // if(data === 'add-ons'){
  //   setRows(newRowsAddOns);
  //   setChangeContract('add-ons');
  // }else if(data === 'change-agreement'){
  //   console.log("newRowsChanged", newRowsChanged)
  //   setRows(newRowsChanged);
  //   setChangeContract('change-agreement');
  // }

  //     }
  //   }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  // const handleDeleteClick = (id) => () => {
  //   // setRows(rows.filter((row) => row.id !== id));
  //   const updatedRows = rows.filter((row) => row.id !== id);

  //   setRows(updatedRows);

  //   // const subTotal = parseFloat(updatedRows.reduce((total, row) => total + Number(row.lineTotal), 0).toFixed(2));
  //   // handleChange("subTotal", subTotal);
  //   // handleChange('totalDiscount', parseFloat(discountAmount.toFixed(2)));
  //   // const grandTotal = parseFloat((subTotal - discountAmount).toFixed(2));
  //   // handleChange("grandTotal", grandTotal);
  //   const subTotal = parseFloat(updatedRows.reduce((total, row) => total + Number(row.lineTotal), 0).toFixed(2));
  //   const totalDiscount = parseFloat(
  //     updatedRows.reduce((total, row) => total + row.price * row.quantity * (row.discount / 100), 0).toFixed(2)
  //   );
  //   const grandTotal = parseFloat((subTotal - totalDiscount).toFixed(2));

  //   handleChange('subTotal', subTotal);
  //   handleChange('totalDiscount', totalDiscount);
  //   handleChange('grandTotal', grandTotal);
  // };

  const handleDeleteClick = (id) => () => {
    const updatedRows = rows.filter((row) => row.id !== id);

    setRows(updatedRows);

    const subTotal = Math.round(updatedRows.reduce((total, row) => total + Number(row.lineTotal), 0).toFixed(2));

    const totalDiscount = Math.round(
      updatedRows
        .reduce((total, row) => {
          if (row.name === 'User') {
            const days = row.days || formData.days || 0;
            return total + row.price * days * row.quantity * (row.discount / 100);
          } else {
            return total + row.price * row.quantity * (row.discount / 100);
          }
        }, 0)
        .toFixed(2)
    );

    const grandTotal = Math.round((subTotal - totalDiscount).toFixed(2));

    handleChange('subTotal', subTotal);
    handleChange('totalDiscount', totalDiscount);
    handleChange('grandTotal', grandTotal);
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = {
      ...newRow,
      serialNumber: rows.findIndex((row) => row.id === newRow.id) + 1,
      lineTotal: calculateLineTotal(
        newRow.quantity,
        newRow.price,
        newRow.discount,
        newRow.itemID,
        formData.days,
        newRow.name
      ),
      isNew: false,
    };

    const updatedRows = rows.map((row) => (row.id === newRow.id ? updatedRow : row));
    setRows(updatedRows);

    const subTotal = Math.round(updatedRows.reduce((total, row) => total + Number(row.lineTotal), 0).toFixed(2));

    const totalDiscount = Math.round(
      updatedRows
        .reduce((total, row) => {
          if (row.name === 'User') {
            return total + row.price * formData.days * row.quantity * (row.discount / 100);
          } else {
            return total + row.price * row.quantity * (row.discount / 100);
          }
        }, 0)
        .toFixed(2)
    );

    const grandTotal = Math.round((subTotal - totalDiscount).toFixed(2));

    handleChange('subTotal', subTotal);
    handleChange('totalDiscount', totalDiscount);
    handleChange('grandTotal', grandTotal);

    return updatedRow;
  };

  // const processRowUpdate = (newRow) => {
  //   const updatedRow = {
  //     ...newRow,
  //     serialNumber: rows.findIndex((row) => row.id === newRow.id) + 1,
  //     lineTotal: calculateLineTotal(newRow.quantity, newRow.price, newRow.discount, newRow.itemID, formData.days, newRow.name),
  //     isNew: false,
  //   };
  //   const updatedRows = rows.map((row) => (row.id === newRow.id ? updatedRow : row));
  //   setRows(updatedRows);

  //   // const subTotal = parseFloat(updatedRows.reduce((total, row) => total + Number(row.lineTotal), 0).toFixed(2));
  //   // handleChange("subTotal", subTotal);
  //   // handleChange("grandTotal", subTotal);
  //   const subTotal = parseFloat(updatedRows.reduce((total, row) => total + Number(row.lineTotal), 0).toFixed(2));
  //   const totalDiscount = parseFloat(
  //     updatedRows.reduce((total, row) => total + row.price * row.quantity * (row.discount / 100), 0).toFixed(2)
  //   );
  //   const grandTotal = parseFloat((subTotal - totalDiscount).toFixed(2));

  //   handleChange('subTotal', subTotal);
  //   handleChange('totalDiscount', totalDiscount);
  //   handleChange('grandTotal', grandTotal);

  //   return updatedRow;
  // };
  //   const processRowUpdate = (newRow) => {
  //     const updatedRow = { ...newRow, isNew: false };
  //     setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
  //     return updatedRow;
  //   };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const calculateDaysDifference = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const timeDiff = end - start;
    return Math.ceil(timeDiff / (1000 * 3600 * 24));
  };

  const columns = [
    //   { field: 'serialNumber', headerName: '#', width: 20, editable: false },
    { field: 'id', headerName: 'Item ID', width: 80, editable: false },
    { field: 'name', headerName: 'Item Name', width: 120, editable: false },
    { field: 'description', headerName: 'Item Description', width: 180, editable: false },

    {
      field: 'uom',
      headerName: 'UOM',
      width: 100,
      editable: false,
      // type: 'singleSelect',
      // valueOptions: ['Market', 'Finance', 'Development'],
    },
    {
      field: 'quantity',
      headerName: 'Quantity',
      type: 'number',
      width: 80,
      align: 'left',
      headerAlign: 'left',
      editable: true,
    },
    {
      field: 'price',
      headerName: 'Price ($)',
      type: 'number',
      width: 80,
      align: 'left',
      headerAlign: 'left',
      editable: false,
    },
    {
      field: 'discount',
      headerName: 'Discount (%)',
      type: 'number',
      width: 120,
      align: 'left',
      headerAlign: 'left',
      editable: true,
    },
    {
      field: 'lineTotal',
      headerName: 'Line Total ($)',
      type: 'number',
      width: 120,
      align: 'left',
      headerAlign: 'left',
      editable: false,
    },
    // { field: 'status', headerName: 'Status', width: 100, editable: true },
    // { field: 'action', headerName: 'Action', width: 80, editable: true },

    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 100,
      cellClassName: 'actions',
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: 'primary.main',
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          // <GridActionsCellItem
          //   icon={<DeleteIcon disabled={rows.length === 1} />}
          //   disabled={rows.length === 1}
          //   label="Delete"
          //   onClick={handleDeleteClick(id)}
          //   color="inherit"
          // />,
        ];
      },
    },
    // {
    //   field: 'createInvoice',
    //   headerName: 'Invoice',
    //   width: 150,
    //   renderCell: (params) =>
    //     params.row.serialNumber === 1 ? (
    //       <Button variant="outlined" size="small" color="primary" onClick={handleCreateInvoice}>
    //         Create Invoice
    //       </Button>
    //     ) : null,
    // },
  ];

  const handleCreateInvoice = (rowData) => {
    // console.log('Creating invoice for:', rows);
    let missFeilds = [];
    rows.forEach((item) => {
      const miss = checkRequiredFields(item);
      if (miss.length > 0) {
        missFeilds.push(miss);
      }
    });
    // console.log('missFeilds', missFeilds);
    if (missFeilds.length === 0) {
      setisOpenInvoiceForm(() => ({
        isOpen: true,
        rowData: rows,
        summaryData: formData,
      }));
    }
  };

  const checkRequiredFields = (item) => {
    const requiredFields = ['lineTotal', 'price', 'quantity'];
    let missingFields = [];
    requiredFields.forEach((field) => {
      if (!item[field] && item[field] != '0') {
        missingFields.push(field);
      }
    });

    if (missingFields.length > 0) {
      toast.error(`The following fields are required: ${missingFields.join(', ')}`);
    }
    // console.log('missing', missingFields);
    return missingFields;
  };

  const getCustomers = async () => {
    try {
      const res = await axios.post(`${Key.domain}/dashboard/getCustomers`, {
        admin_id: currentUser?.id,
        session_token: currentUser?.session_token,
      });
      if (res.status === 200) {
        const newData = res.data.data;
        // console.log('newData', newData);
        // setCustomerData(newData);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        if (
          error.response.data.data === 'Access denied.. Please Login' ||
          error.response.data.data === 'Access denied'
        ) {
          setSessionAlert(true);
        }
      }
      console.error(error);
    }
  };

  const getPriceList = async () => {
    try {
      const response = await axios.get(`${Key.domain}/payment/item/configurations`);
      if (response.status === 200) {
        // console.log(response.data);
        const resData = response.data.data;
        setPriceListData(resData);
        setFormData((prev) => ({
          ...prev,
          priceList: { id: 1, name: 'Monthly' },
        }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const actionsHandler = (action) => {
    // console.log('actions handler', action);
    if (action === 'hold') {
      setIsHoldReasonOpen(true);
    }
    if (action === 'update') {
      setAction('update');
    }
  };

  const holdReasonHandler = () => {
    setIsHoldReasonOpen(false);
  };

  const getItemById = async (id) => {
    try {
      const response = await axios.get(`${Key.domain}/payment/item/configurations/${id}`);
      if (response.status === 200) {
        // console.log(response);
        const resData = response.data.data[0];
        setPriceListDataByID(resData);

        try {
          const parsedItems = JSON.parse(`[${resData.items}]`);

          //formData.priceList === "Monthly"

          const newRows = parsedItems.map((item, index) => {
            let basicQuantity =
              item.name === 'Profile'
                ? 1200
                : item.name === 'User'
                ? 3
                : item.name === 'Job'
                ? 10000
                : item.name === 'Support'
                ? 1
                : '';

            return {
              id: item.item_id && item.item_id !== '' ? item.item_id : item.id,
              itemID: item.item_id,
              name: item.name,
              description: item.description,
              uom: item.uom,
              quantity: basicQuantity,
              price: item.price,
              discount: '',
              lineTotal: calculateLineTotal(basicQuantity, item.price, 0, item.item_id, formData.days, item.name),
              status: '',
              action: '',
              isNew: true,
              serialNumber: index + 1,
            };
          });

          setSelectedPriceListItems(parsedItems);
          if (id == 1 && changeContract === null) {
            // setRows((oldRows) => [...oldRows, ...newRows]);
            setRows((oldRows) => [...newRows]);
            const updatedRows = newRows;

            const subTotal = Math.round(
              updatedRows.reduce((total, row) => total + Number(row.lineTotal), 0).toFixed(2)
            );

            const totalDiscount = Math.round(
              updatedRows
                .reduce((total, row) => {
                  if (row.name === 'User') {
                    return total + row.price * formData.days * row.quantity * (row.discount / 100);
                  } else {
                    return total + row.price * row.quantity * (row.discount / 100);
                  }
                }, 0)
                .toFixed(2)
            );

            const grandTotal = Math.round((subTotal - totalDiscount).toFixed(2));

            handleChange('subTotal', subTotal);
            handleChange('totalDiscount', totalDiscount);
            handleChange('grandTotal', grandTotal);
          }

          //   setRows((oldRows) => [...oldRows, ...newRows]);

          // Updating row modes for each new row
          //   newRows.forEach(row => {
          //     setRowModesModel((oldModel) => ({
          //       ...oldModel,
          //       [row.id]: { mode: GridRowModes.Edit, fieldToFocus: 'quantity' },
          //     }));
          //   });
        } catch (error) {
          console.error('Error parsing items:', error);
        }
      }
    } catch (error) {
      console.error('Error fetching item by ID:', error);
    }
  };

  const generateInvoiceId = () => {
    // const paddedUserId = customerDetails ? customerDetails?.id.toString().padStart(6, '0') : '0';
    const newContractId = `IN${currentUser?.id}${moment().format('YYYYMMDDhhmmss')}`;
    // console.log('moment().format("YYYYMMDDHHMM")', moment().format("YYYYMMDDhhmmss"));
    return newContractId;
  };

  const saveContract = async () => {
    const itemsData = [];
    rows.map((data) => {
      const line = {
        id: data.itemID,
        contract_number: formData.id,
        name: data.name,
        description: data.description,
        type: '',
        uom: data.uom,
        quantity: data.quantity,
        price: data.price,
        discount: data.discount,
        lineTotal: data.lineTotal,
        status: data.status,
      };
      itemsData.push(line);
    });
    // console.log("items data", itemsData);
    try {
      const response = await axios.post(`${Key.domain}/payment/contract`, {
        admin_id: currentUser.id,
        customer_id: selectedContract?.customer_id,
        number: generateContractId(),
        start_date: moment(formData.startDate).format('YYYY-MM-DD HH:mm:ss'),
        end_date: moment(formData.endDate).format('YYYY-MM-DD HH:mm:ss'),
        sub_total: formData.subTotal.toString(),
        tax: '0',
        duration: formData.duration,
        period: formData.period,
        description: formData.description,
        items: itemsData,
        price_list_id: formData.priceList.id,
        total: formData.grandTotal.toString(),
        discount: formData.totalDiscount.toString(),
        company_id: selectedContract?.company_id,
        parent_contract: selectedContract?.id,
        contract_action: action === 'update' ? 1 : 0,
      });
      // console.log(response);
      if (response.status === 200) {
        const res = response.data.data;
        if (res?.msg === 'Contract is already exists on your company') {
          toast.error(res.msg);
        } else {
          try {
            const response = await axios.post(`${Key.domain}/payment/invoice`, {
              number: generateInvoiceId(),
              admin_id: currentUser?.id,
              company_id: res?.company_id,
              customer_id: res?.customer_id,
              contract_number: res?.number,
              invoice_date: moment().format('YYYY-MM-DD HH:mm:ss'),
              sub_total: res?.sub_total.toString(),
              discount: res?.discount.toString(),
              tax: res?.tax.toString(),
              total: res?.total.toString(),
              payment_terms: 'DOR',
              due_date: moment().format('YYYY-MM-DD HH:mm:ss'),
              address1: res.address1,
              address2: res.address2,
              trail_days: res?.trail_days,
            });
            // console.log('invoice response', response);
            if (response.status === 200) {
              setSelectedCustomerDetails(response.data.data);
              //   setAddContractOpen(false);
              toast.success('Summary Added Successfully');
            }
          } catch (error) {
            console.error(error);
            toast.error('Something went wrong try again..!');
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDownload = async () => {
    const customerId = selectedContract?.customer_id;
    const fileName = selectedContract?.file_name;
    try {
      const response = await axios.get(`${Key.domain}/payment/contract/${customerId}/${fileName}`, {
        responseType: 'blob',
      });

      const blob = new Blob([response.data], { type: response.headers['content-type'] });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  function EditToolbar(props) {
    const { setRows, setRowModesModel, priceListData, setPriceListDataByID, actionsHandler } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
      if (!formData.priceList || !formData.endDate) {
        if (!formData.priceList) {
          toast.error('Select Price List to add item');
        } else if (!formData.endDate) {
          toast.error('Select End Date to add item');
        }
      } else {
        setAnchorEl(event.currentTarget);
      }
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleMenuItemHandler = async (data) => {
      // console.log('data by id', data);
      if (changeContract === 'add-ons') {
        await setAddOnRows((prev) => prev + 1);
      }

      const newRowId = changeContract === 'add-ons' ? addOnRows + 1 : rows.length + 1; // Ensure addOnRows is incremented
      let newRow = {
        serialNumber: newRowId,
        id: data.item_id,
        itemID: data.item_id,
        name: data.name,
        description: data.description,
        uom: data.uom,
        quantity: '',
        price: data.price,
        discount: '',
        lineTotal: '',
        status: '',
        action: '',
        isNew: true,
      };

      if (data.name === 'Profile') {
        let quantity = 0;
        if (formData.days < 32) {
          quantity = formData.days * 40;
        } else if (formData.days >= 32 && formData.days < 92) {
          quantity = formData.days * 45;
        } else if (formData.days >= 92 && formData.days < 182) {
          quantity = formData.days * 55;
        } else if (formData.days >= 182) {
          quantity = formData.days * 65;
        }
        newRow = {
          ...newRow,
          quantity: quantity,
          lineTotal: calculateLineTotal(quantity, data.price, 0, data.item_id, formData.days, data.name),
        };
      }

      setRows((oldRows) => [...oldRows, newRow]);
    };

    // const handleMenuItemHandler = async (data) => {
    //   //   const data =await getItemById(id);
    //   console.log('data by id', data);
    //   if(changeContract === 'add-ons'){
    //  await  setAddOnRows((prev) => prev + 1);
    //   }
    //   const newRowId =await changeContract === 'add-ons' ? addOnRows : rows.length + 1;
    //   let newRow = {
    //     serialNumber: newRowId,
    //     id: data.item_id,
    //     name: data.name,
    //     description: data.description,
    //     uom: data.uom,
    //     quantity: '',
    //     price: data.price,
    //     discount: '',
    //     lineTotal: '',
    //     status: '',
    //     action: '',
    //     isNew: true,
    //   };
    //   if(data.item_id === 'QKEAP6'){
    //   if(formData.days < 32){
    //     newRow = {
    //       ...newRow,
    //       quantity: formData.days * 40,
    //       lineTotal: calculateLineTotal((formData.days * 40), data.price, 0, data.item_id)
    //     }
    //   }
    //   else if(32 <= formData.days < 92){
    //     newRow = {
    //       ...newRow,
    //       quantity: formData.days * 45,
    //       lineTotal: calculateLineTotal((formData.days * 45), data.price, 0, data.item_id)
    //     }
    //   }else if(92 <= formData.days < 182){
    //     newRow = {
    //       ...newRow,
    //       quantity: formData.days * 55,
    //       lineTotal: calculateLineTotal((formData.days * 55), data.price, 0, data.item_id)
    //     }
    //   }else if(182 <= formData.days){
    //     newRow = {
    //       ...newRow,
    //       quantity: formData.days * 65,
    //       lineTotal: calculateLineTotal((formData.days * 65), data.price, 0, data.item_id)
    //     }
    //   }
    // }
    //   setRows((oldRows) => [...oldRows, newRow]);
    // };
    // console.log(rows);

    // const getItemById = async (id) => {
    //     try {
    //       const response = await axios.get(`${Key.domain}/payment/item/configurations/${id}`);
    //       if (response.status === 200) {
    //         console.log(response);
    //         const resData = response.data.data[0]; // Assuming data is an array and you're getting the first element
    //         setPriceListDataByID(resData);

    //         try {
    //           // Parsing items correctly
    //           const parsedItems = JSON.parse(`[${resData.items}]`);

    //           // Creating new rows with unique IDs
    //           const newRows = parsedItems.map(item => ({
    //             id: item.item_id,
    //             name: item.name,
    //             description: item.description,
    //             uom: item.uom,
    //             quantity: '',
    //             price: item.price,
    //             discount: '',
    //             lineTotal: '',
    //             status: '',
    //             action: '',
    //             isNew: true
    //           }));

    //         setSelectedPriceListItems(parsedItems);

    //         //   setRows((oldRows) => [...oldRows, ...newRows]);

    //           // Updating row modes for each new row
    //         //   newRows.forEach(row => {
    //         //     setRowModesModel((oldModel) => ({
    //         //       ...oldModel,
    //         //       [row.id]: { mode: GridRowModes.Edit, fieldToFocus: 'quantity' },
    //         //     }));
    //         //   });
    //         } catch (error) {
    //           console.error('Error parsing items:', error);
    //         }
    //       }
    //     } catch (error) {
    //       console.error('Error fetching item by ID:', error);
    //     }
    //   };

    // const handleClick = () => {
    //   const id = 'bfdbh';
    //   setRows((oldRows) => [...oldRows, { id, name: '', mou: '', price: '', isNew: true }]);
    //   setRowModesModel((oldModel) => ({
    //     ...oldModel,
    //     [id]: { mode: GridRowModes.Edit, fieldToFocus: 'id' },
    //   }));
    // };

    return (
      <GridToolbarContainer>
        <Button
          color="primary"
          startIcon={<AddIcon />}
          id="fade-button"
          aria-controls={open ? 'fade-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          // onClick={handleAddRow}
          onClick={handleClick}
          // disabled={!formData.priceList}
          disabled
        >
          Add Item
        </Button>
        <Menu
          id="fade-menu"
          MenuListProps={{
            'aria-labelledby': 'fade-button',
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          {selectedPriceListItems?.map((data) => (
            <MenuItem onClick={() => handleMenuItemHandler(data)}>{data?.name}</MenuItem>
          ))}
        </Menu>
        <Box sx={{ flexGrow: 1 }} />
      </GridToolbarContainer>
    );
  }

  const handleAddRow = () => {
    const newRowId = rows.length + 1;
    const newRow = {
      id: newRowId,
      serialNumber: newRowId,
      name: '',
      description: '',
      uom: '',
      quantity: 1,
      price: 0,
      discount: 0,
      lineTotal: 0,
      status: 'pending',
      isNew: true,
    };
    setRows([...rows, newRow]);
    setRowModesModel({
      ...rowModesModel,
      [newRowId]: { mode: GridRowModes.Edit, fieldToFocus: 'name' },
    });
  };

  const getStatusList = async () => {
    try {
      const response = await axios.get(`${Key.domain}/payment/contract/status_list`);
      if (response.status === 200) {
        console.log(response.data);
        setStatusData(response.data.data);
        const data = response.data.data;
        const initialStatus = await data.filter((item) => item.status_id == 1);
        console.log('status check initial', initialStatus);
        handleChange('status', initialStatus[0]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const contractAddedSuccessHandler = () => {
    //   setAddContractOpen(false);
  };

  const textStyles = {
    fontSize: styles.fontSize12,
    fontWeight: 600,
  };
  return sessionAlert ? (
    <SessionAlert />
  ) : (
    <Grid container spacing={0}>
      <Grid item xs={12}>
        <Toolbar>
          <Typography variant="body1" sx={{ fontSize: '14px', fontWeight: 700 }}>{`Summary ${
            selectedContract
              ? `(${selectedContract?.company_name} - ${selectedContract?.full_name})`
              : '(Select Customer)'
          }`}</Typography>
          <ViewContract selectedContract={selectedContract} />
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: 'flex', gap: '5px' }}>
            {changeContract === 'add-ons' ? (
              <></>
            ) : (
              ((changeContract === 'change-agreement' && action === 'update') || !changeContract) && (
                <>
                  <CreateAgreementButton
                    rows={rows}
                    formData={formData}
                    changeContract={changeContract}
                    action={action}
                    customerData={selectedContract}
                    selectedContract={selectedContract}
                    setSelectedCustomerDetails={setSelectedCustomerDetails}
                    contractAddedSuccessHandler={contractAddedSuccessHandler}
                  />
                  <Button
                    variant="contained"
                    disabled={changeContract === 'change-agreement' && action !== 'update'}
                    disableElevation
                    onClick={saveContract}
                  >
                    {' '}
                    Save{' '}
                  </Button>
                </>
              )
            )}
            <ContractActions actionsHandler={actionsHandler} />
          </Box>
        </Toolbar>
        <Divider sx={{ m: '5px' }} />
      </Grid>
      <Grid item xs={12}>
        <Grid
          container
          spacing={1}
          sx={{
            '.css-r0m7rw-MuiInputBase-root-MuiOutlinedInput-root': {
              height: '34.5px',
            },
            '.css-fecy4l.Mui-disabled': {
              height: '34.5px',
            },
            '& .MuiInputBase-input': {
              fontSize: '12px',
            },
            p: '10px',
          }}
        >
          <Grid item xs={3}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Customer
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  disabled
                  placeholder="Customer Email"
                  size="small"
                  value={formData.customerEmail}
                  onChange={(e) => handleChange('customerEmail', e.target.value)}
                  // error={Boolean(formErrors.customerEmail)}
                  // helperText={formErrors.customerEmail}
                  id="customerEmail"
                  autoComplete="off"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Package
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <Autocomplete
                  size="small"
                  disablePortal
                  disabled={!action}
                  fullWidth
                  options={packages}
                  getOptionLabel={(option) => option || ''}
                  value={formData.package || null}
                  // onInputChange={(event, newInputValue) => handlePriceListInputChange(newInputValue)}
                  onChange={(event, newValue) => handleChange('package', newValue)}
                  renderInput={(params) => <TextField {...params} placeholder="Select Package" />}
                  // error={formErrors.package}
                  // helperText={formErrors.package}
                  id="package"
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={3}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Price List
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <Autocomplete
                  size="small"
                  disablePortal
                  fullWidth
                  disabled={!action}
                  options={formData.package === 'Standard' ? plans : priceListData}
                  getOptionLabel={(option) => option.name || ''}
                  value={formData.priceList || null}
                  // onInputChange={(event, newInputValue) => handlePriceListInputChange(newInputValue)}
                  onChange={(event, newValue) => handleChange('priceList', newValue)}
                  renderInput={(params) => <TextField {...params} placeholder="Select Price List" />}
                  // error={formErrors.priceList}
                  // helperText={formErrors.priceList}
                  id="priceList"
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={3}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Sub Total
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  disabled
                  placeholder="Sub Total"
                  size="small"
                  type="number"
                  value={formData.subTotal}
                  onChange={(e) => handleChange('subTotal', e.target.value)}
                  // error={Boolean(formErrors.subTotal)}
                  // helperText={formErrors.subTotal}
                  id="subTotal"
                  autoComplete="off"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">$</InputAdornment>,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={3} sx={{ alignItems: 'center' }}>
            <Grid item container spacing={0} xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Number
                  </Typography>
                </Box>
              </Grid>
              <Grid xs={8}>
                <TextField
                  fullWidth
                  disabled
                  placeholder="Number"
                  size="small"
                  value={formData.id}
                  onChange={(e) => handleChange('id', e.target.value)}
                  // error={Boolean(formErrors.itemDescription)}
                  // helperText={formErrors.itemDescription}
                  id="id"
                  autoComplete="off"
                />
              </Grid>
              {/* <Box sx={{display: 'flex', gap:'5px', alignItems: 'center'}}>
                      
                     
                      </Box> */}
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Start Date
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <MobileDatePicker
                    sx={{ width: '100%' }}
                    value={formData.startDate}
                    disabled={formData.package === 'Standard'}
                    // minDate={moment()}
                    onChange={(newValue) => handleChange('startDate', newValue)}
                    renderInput={(params) => <TextField fullWidth {...params} sx={{ width: '100%' }} />}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    End Date
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <MobileDatePicker
                    sx={{ width: '100%' }}
                    value={formData.endDate}
                    minDate={formData.startDate}
                    disabled={formData.package === 'Standard'}
                    onChange={(newValue) => handleChange('endDate', newValue)}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Discount
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  disabled
                  placeholder="Discount"
                  size="small"
                  value={formData.totalDiscount}
                  onChange={(e) => handleChange('totalDiscount', e.target.value)}
                  // error={Boolean(formErrors.totalDiscount)}
                  // helperText={formErrors.totalDiscount}
                  id="totalDiscount"
                  autoComplete="off"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">$</InputAdornment>,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Status
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <Autocomplete
                  size="small"
                  disablePortal
                  disabled
                  fullWidth
                  options={statusData}
                  getOptionLabel={(option) => option.status_name}
                  value={formData.status !== '' ? formData.status : null}
                  onChange={(event, newValue) => handleChange('status', newValue)}
                  renderInput={(params) => <TextField {...params} placeholder="Status" />}
                  // error={formErrors.status}
                  // helperText={formErrors.status}
                  id="status"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Duration
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  disabled
                  placeholder="duration"
                  size="small"
                  value={formData.duration}
                  onChange={(e) => handleChange('duration', e.target.value)}
                  // error={Boolean(formErrors.duration)}
                  // helperText={formErrors.duration}
                  id="duration"
                  autoComplete="off"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Period
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  disabled
                  placeholder="period"
                  size="small"
                  value={formData.period}
                  onChange={(e) => handleChange('period', e.target.value)}
                  // error={Boolean(formErrors.period)}
                  // helperText={formErrors.period}
                  id="period"
                  autoComplete="off"
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={3}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Tax
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  disabled
                  placeholder="Tax"
                  size="small"
                  value={formData.tax}
                  onChange={(e) => handleChange('tax', e.target.value)}
                  // error={Boolean(formErrors.tax)}
                  // helperText={formErrors.tax}
                  id="tax"
                  autoComplete="off"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">$</InputAdornment>,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={6} sx={{ alignItems: 'center' }}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={2}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Description
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  placeholder="Description"
                  size="small"
                  value={formData.description}
                  onChange={(e) => handleChange('description', e.target.value)}
                  // error={Boolean(formErrors.description)}
                  // helperText={formErrors.description}
                  id="description"
                  autoComplete="off"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Trail Period
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <Box sx={{ display: 'flex', gap: '2px', alignItems: 'center' }}>
                  <Checkbox checked={formData.isTrail} onChange={(e) => handleChange('isTrail', e.target.checked)} />
                  {/* <Typography variant="body2" sx={{ ...textStyles }} >3 Days</Typography> */}
                  <TextField
                    fullWidth
                    disabled
                    placeholder="Trail Days"
                    size="small"
                    type="number"
                    value={formData.trailDays}
                    onChange={(e) => handleChange('trailDays', e.target.value)}
                    // error={Boolean(formErrors.trailDays)}
                    // helperText={formErrors.trailDays}
                    id="trailDays"
                    autoComplete="off"
                    InputProps={{
                      endAdornment: <InputAdornment position="end">days</InputAdornment>,
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Total
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  disabled
                  placeholder="Grand Total"
                  size="small"
                  type="number"
                  value={formData.grandTotal}
                  onChange={(e) => handleChange('grandTotal', e.target.value)}
                  // error={Boolean(formErrors.grandTotal)}
                  // helperText={formErrors.grandTotal}
                  id="grandTotal"
                  autoComplete="off"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">$</InputAdornment>,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 0, borderColor: 'divider' }}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              aria-label="basic tabs example"
              sx={{
                minHeight: '32px',
                '& .MuiTab-root': {
                  fontSize: styles.fontSize12,
                  minHeight: '32px', // Ensure individual tabs also decrease in height
                  padding: '6px 12px', // Adjust padding
                  minWidth: '60px', // Decrease tab width
                },
                '& .Mui-selected': {
                  color: '#1976d2 !important',
                  // backgroundColor: '#e3f2fd',
                },
                '& .MuiTabs-indicator': {
                  backgroundColor: '#1976d2',
                },
              }}
            >
              <Tab label="Lines" {...a11yProps(0)} />
              {/* <Tab label="Renewals" {...a11yProps(1)} />
              <Tab label="Administration" {...a11yProps(2)} /> */}
            </Tabs>
          </Box>
          <CustomTabPanel value={tabValue} index={0}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Box
                  sx={{
                    // height: 500,
                    width: '100%',
                    '& .actions': {
                      color: 'text.secondary',
                    },
                    '& .textPrimary': {
                      color: 'text.primary',
                    },
                  }}
                >
                  <DataGrid
                    autoHeight
                    rows={rows}
                    columns={columns}
                    editMode="row"
                    rowModesModel={rowModesModel}
                    onRowModesModelChange={handleRowModesModelChange}
                    onRowEditStop={handleRowEditStop}
                    processRowUpdate={processRowUpdate}
                    hideFooter
                    pagination={false}
                    slots={{
                      toolbar: EditToolbar,
                    }}
                    slotProps={{
                      toolbar: { setRows, setRowModesModel, priceListData, setPriceListDataByID, actionsHandler },
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </CustomTabPanel>
          <CustomTabPanel value={tabValue} index={1}>
            Renewals
          </CustomTabPanel>
          <CustomTabPanel value={tabValue} index={2}>
            Administration
          </CustomTabPanel>
        </Box>
      </Grid>
      <HoldReason isHoldReasonOpen={isHoldReasonOpen} holdReasonHandler={holdReasonHandler} />
      <InvoiceForm
        isOpenInvoiceForm={isOpenInvoiceForm}
        customerDetails={selectedContract}
        contract_number={formData.id}
      />
      <CustomerConfirmationDialog
        isOpen={customerConfirmationDilogOpen}
        customerData={selectedContract}
        contractConfirmationHandler={contractConfirmationHandler}
      />
    </Grid>
  );
};

export default Summary;
